import { render, staticRenderFns } from "./Hue.vue?vue&type=template&id=2c7462e2&"
import script from "./Hue.vue?vue&type=script&lang=js&"
export * from "./Hue.vue?vue&type=script&lang=js&"
import style0 from "./Hue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports